function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M29.2 12.4c.2-.2.3-.4.3-.6 0-.2-.1-.5-.2-.6-.1-.1-.3-.2-.5-.3l-8.3-1.2c-.5-.1-.8-.4-1-.7l-3.7-7.6c-.2-.4-.8-.6-1.2-.4-.2.1-.3.2-.4.4L10.5 9c-.2.4-.5.6-.9.7l-8.3 1.2c-.2 0-.4.1-.6.3-.1.2-.2.4-.2.7 0 .2.1.4.3.5l6 5.9c.3.3.4.7.3 1.1l-1.4 8.3c-.1.5.3.9.8 1 .2 0 .4 0 .5-.1l7.4-3.9c.2-.1.4-.1.6-.1.2 0 .4 0 .6.1l7.4 3.9c.2.1.5.1.7 0 .2-.1.4-.2.5-.4.1-.2.1-.4.1-.6l-1.4-8.2c-.1-.4.1-.8.4-1.1l5.9-5.9zm-7.5 7.1l1.3 7.7-6.9-3.6c-.7-.4-1.5-.4-2.2 0L7 27.2l1.3-7.7c.1-.8-.1-1.6-.7-2.1L2 11.9l7.7-1.1c.8-.1 1.5-.6 1.8-1.3l3.5-7 3.5 7c.3.7 1 1.2 1.8 1.3l7.7 1.1-5.6 5.5c-.6.5-.8 1.3-.7 2.1zM17.9 13l.9.7-4.9 6-2.6-2.7.8-.8 1.7 1.8 4.1-5z"
})));